import {sendCustomMetric} from '@github-ui/stats'

type PolicyMetricKey =
  | 'TRUSTED_TYPES_POLICY_CALLED'
  | 'TRUSTED_TYPES_POLICY_ERROR'
  | 'TRUSTED_TYPES_POLICY_INITIALIZED_TWICE'

export function createPolicyMetricEmitter(policyName: string): (name: PolicyMetricKey) => void {
  const tags = {trusted_types_policy_name: policyName}
  let metricsDisabled = false

  return name => {
    if (metricsDisabled) return
    try {
      sendCustomMetric({name, value: 1, tags})
    } catch {
      // Telemetry must not affect minting. Stop retrying a broken sink on every
      // use of this policy, including hot paths such as HTML rendering.
      metricsDisabled = true
    }
  }
}
